var map = {
	"./batch.png": "86em",
	"./converter.png": "MjAw",
	"./devices.png": "gSxb",
	"./easy.png": "ZAHJ",
	"./fast.png": "9wH+",
	"./icon-arrow.png": "+1RY",
	"./icon-setting.png": "xwTY",
	"./icon-tips.png": "z4FN",
	"./security.png": "JTPj",
	"./setting.png": "2Vuu",
	"./strong.png": "V3qF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";